import { ApiDatumResponse, ApiDataResponse } from '@api/v4/ApiResponseTypes';

export type PortalCardsResponse = ApiDataResponse<BackendPortalCard>;

export type PortalCardResponse = ApiDatumResponse<BackendPortalCard>;

export enum PortalCardTypes {
  PortalTile="PortalTile",
  PortalLink="PortalLink",
  PortalWidget="PortalWidget"
}

export enum PortalCardSubTypes {
  InternalLink="internal_link",
  ExternalLink="external_link",
  RecentlyCreatedAssetsWidget="recently_created_assets",
  RecentlyUpdatedAssetsWidget="recently_updated_assets",
  TopScoredAssetsWidget="top_scored_assets",
  FeatureTaggedAssetsWidget="featured_tagged_assets"
}

export enum DisplayWidths {
  OneThird="one-third",
  TwoThirds="two-thirds",
  Full="full"
}

export interface WidgetResource {
  type: string;
  key: string;
  name?: string;
}

export interface PortalCard {
  name: string;
  type: PortalCardTypes;
  description?: string;
  displayWidth?: DisplayWidths;
  iconUrl?: string;
  imageUrl?: string;
  linkUrl?: string;
  position?: number;
  subType?: PortalCardSubTypes;
  widgetResource?: WidgetResource;
}

export interface BackendPortalCard {
  name: string;
  type: PortalCardTypes;
  description?: string;
  display_width?: DisplayWidths;
  icon_url?: string;
  image_url?: string;
  link_url?: string;
  position?: number;
  sub_type?: PortalCardSubTypes;
}

export enum ValidationErrors {
  DescriptionLengthExceeded="Description length exceeded",
  InvalidLink="Invalid link url",
  InvalidResource="Invalid Brandfolder",
  MissingLink="Link required",
  MissingName="Name required",
  MissingSubType="Please select a type",
  MissingResource="A Brandfolder is required",
  NameLengthExceeded="Name length exceeded",
}
